
namespace TabAurous.Inventory {
    import fld = CertificationReturnBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class CertificationReturnBOMEditor extends _Ext.BOMGridEditor<CertificationReturnBOMRow> { 
        protected getDialogType() { return CertificationReturnBOMDialog; }
        protected getLocalTextPrefix() { return CertificationReturnBOMRow.localTextPrefix; } 

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as Inventory.CertificationReturnItemsDialog).CalculateTotals();
                }
            })

        }  
 
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.RawMaterialMasterSelectGrid;

            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var Inventorydetails = [];
                        var ratelistId = this.RateListId;
                        selectedItems2.forEach(function (value) {
                            var prdid = value.ProductId;

                            var PrdDetails = value;

                            var Pieces = 0;
                            var Weight = 0.01;
                            var Rate = 0;
                            var Amount = 0;

                            if (PrdDetails.ItemTypeId == 104) {
                                var MetalRate = GetItemRateHelper.GetGetMetalRate(PrdDetails.ProductTypeId);
                                Rate = MetalRate;
                                Amount = Rate * Weight * PrdDetails.Purity;

                            }
                            else {
                                var ItemRate = GetItemRateHelper.GetSalesRate(PrdDetails.AttributeId, ratelistId);
                                Rate = ItemRate;
                                Pieces = 1;
                                if (PrdDetails.CalcOnId == 3) {
                                    Amount = Rate * Pieces
                                }
                                else {
                                    Amount = Rate * Weight;
                                }
                            }


                            var InventoryBom: CertificationReturnBOMRow = {
                                BOMProductId: prdid,

                                ProductCode: value.ProductCode,
                                BOMAttributeId: value.AttributeId,
                                Attribute: PrdDetails.Attribute,
                                ItemType: PrdDetails.ItemType,
                                ItemTypeId: PrdDetails.ItemTypeId,

                                StoneColorId: PrdDetails.StoneColorId,
                                MetalColorId: PrdDetails.MetalColorId,
                                KaratId: PrdDetails.KaratId,

                                BomRate: Rate,
                                Pieces: Pieces,
                                Weight: Weight,
                                CalcOn: value.CalcOnId,
                                ShapeId: PrdDetails.ShapeId,
                                QualityId: PrdDetails.QualityId,

                                Purity: PrdDetails.Purity,
                                BomAmount: Amount
                            };
                            Inventorydetails.push(InventoryBom);

                        });


                        for (let InventoryDetail of Inventorydetails) {
                            InventoryDetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(InventoryDetail);
                        }
                    }

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
         
    }
}